import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Particles } from "@/components/magicui/particles";
import { useTheme } from "@/lib/theme-provider";

const TryNowSection: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  // Couleur des particules selon le thème
  const particleColor = theme === "dark" ? "#ffffff" : "#1e293b";

  return (
    <section className="relative flex flex-col  items-center justify-center min-h-[500px] md:min-h-[600px] w-full rounded-3xl overflow-hidden bg-gradient-to-br from-white via-blue-50 to-sky-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 border border-neutral-200 dark:border-neutral-700 shadow-2xl mx-auto mt-6 mb-12 px-4">
      {/* Particles Background */}
      <Particles
        className="absolute inset-0 z-0 pointer-events-none"
        quantity={80}
        ease={80}
        color={particleColor}
        size={1.2}
        staticity={40}
        vx={0.1}
        vy={0.1}
      />

      {/* Grid overlay */}
      <div className="absolute inset-0 z-[1] pointer-events-none">
        <svg
          width="100%"
          height="100%"
          className="w-full h-full"
          style={{ opacity: 0.1 }}
        >
          <defs>
            <pattern
              id="grid-trynow"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 40 0 L 0 0 0 40"
                fill="none"
                stroke={theme === "dark" ? "#ffffff" : "#000000"}
                strokeOpacity="0.08"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-trynow)" />
        </svg>
        <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-sky-100/20 dark:from-black/20 dark:to-slate-900/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-3xl py-12">
        {/* Headline */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center dark:text-white text-gray-700 mb-6 leading-tight">
          {t("home.tryNow.title")}
        </h1>

        {/* Subtitle */}
        <p className="dark:text-neutral-300 text-neutral-600 text-base md:text-lg text-center max-w-xl mb-8">
          {t("home.tryNow.subtitle")}
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={() => navigate("/register")}>
            {t("home.tryNow.tryNow")}
          </Button>
          <Link
            to="https://calendly.com/mohamedmernit-conceptpaiesolutions/30min"
            target="_blank"
          >
            <Button variant="ghost">{t("home.tryNow.bookDemo")}</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TryNowSection;
